import { useQuery } from '@tanstack/react-query';
import { getDashboardObjectById, getDashboardWidgets } from 'src/services/account';
import processDashboardData from '../processDashboardData';

export const useDashboardQueries = (dashboardId: string) => {
  const dashboardQueryKey = ['dashboard', { id: dashboardId }];

  const {
    data: dashboardData,
    isLoading,
    refetch: refetchDashboard
  } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['dashboard', { id: dashboardId }],
    queryFn: async () => {
      const res = await getDashboardObjectById(dashboardId);

      return processDashboardData(res.data);
    },
    enabled: !!dashboardId,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });

  const { data: dashboardWidgets } = useQuery({
    queryKey: ['dashboardWidgets'],
    queryFn: async () => {
      const res = await getDashboardWidgets({ ignoreOwner: true });

      return res.data;
    },
    placeholderData: [],
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });

  return {
    dashboardQueryKey,
    dashboardData,
    dashboardWidgets,
    isLoading,
    refetchDashboard
  };
};
